export enum SodanQuestionCodeEnum {
  WORRIED_ABOUT_KEYS = 'WORRIED_ABOUT_KEYS',
  WORRIED_ABOUT_BREAKDOWN = 'WORRIED_ABOUT_BREAKDOWN',
  FINANCIAL_LOSS_CONCERNED = 'FINANCIAL_LOSS_CONCERNED',
  SODAN_LEGAL_CAPACITY_ACTING = 'SODAN_LEGAL_CAPACITY_ACTING',
  SPECIAL_VEHICLE_SHOW = 'SPECIAL_VEHICLE_SHOW',
}
